// John Eldhose 20190214
const Americas = ['Anguilla', 'Antigua and Barbuda', 'Argentina', 'Aruba', 'Bahamas', 'Barbados', 'Belize', 'Bermuda', 'Bolivia', 'Brazil', 'British Virgin Islands', 'Canada', 'Caribbean Netherlands', 'Cayman Islands', 'Chile', 'Colombia', 'Costa Rica', 'Cuba', 'Curaçao', 'Dominica', 'Dominican Republic', 'Ecuador', 'El Salvador', 'Falkland Islands', 'French Guiana', 'Greenland', 'Grenada', 'Guadeloupe', 'Guatemala', 'Guyana', 'Haiti', 'Honduras', 'Jamaica', 'Martinique', 'Mexico', 'Montserrat', 'Nicaragua', 'Panama', 'Paraguay', 'Peru', 'Puerto Rico', 'Saint Barthélemy', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Martin', 'Saint Pierre and Miquelon', 'Saint Vincent and the Grenadines', 'Sint Maarten', 'Suriname', 'Trinidad and Tobago', 'Turks and Caicos Islands', 'United States', 'United States Virgin Islands', 'Uruguay', 'Venezuela'];
const APAC = ['American Samoa', 'Australia', 'Bangladesh', 'Bhutan', 'Brunei', 'Cambodia', 'China', 'Cook Islands', 'Fiji', 'French Polynesia', 'Guam', 'India', 'Indonesia', 'Japan', 'Kiribati', 'Laos', 'Malaysia', 'Maldives', 'Marshall Islands', 'Micronesia', 'Mongolia', 'Myanmar', 'Nauru', 'Nepal', 'New Caledonia', 'New Zealand', 'Niue', 'North Korea', 'Northern Mariana Islands', 'Pakistan', 'Palau', 'Papua New Guinea', 'Philippines', 'Samoa', 'Singapore', 'Solomon Islands', 'South Korea', 'Sri Lanka', 'Taiwan', 'Thailand', 'Tokelau', 'Tonga', 'Tuvalu', 'Vanuatu', 'Vietnam', 'Wallis And Futuna'];
const Currency = { USD: '$' };
const Price = {
  'Quarryman LR System': {
    USD:[13963.33, 13963.33, 13963.33, 10645.73, 10645.73, 10645.73, 10645.73, 10645.73, 10645.73, 10645.73]
  },
  'Quarryman SR System': {
    USD:[14627.75, 14627.75, 14627.75, 10760.16, 10760.16, 10760.16, 10760.16, 10760.16, 10760.16, 10760.16]
  },
  'WIFI Voidscanner System': {
    USD:[23538.32, 23538.32, 23538.32, 15770.67, 15770.67, 15770.67, 12059.28, 12059.28, 12059.28, 12059.28]
  },
  'Voidscanner System': {
    USD:[20745.63, 20745.63, 20745.63, 13899.57, 13899.57, 13899.57, 10325.85, 10325.85, 10325.85, 10325.85]
  },
  'VS+ System': {
    USD:[20746.51, 20746.51, 20746.51, 13900.16, 13900.16, 13900.16, 10325.85, 10325.85, 10325.85, 10325.85]
  },
  'Cabled 35M Boretrak': {
    USD:[8511.02, 8511.02, 8511.02, 6058.32, 6058.32, 6058.32, 6058.32, 6058.32, 6058.32, 6058.32]
  },
  'Cabled 65M Boretrak': {
    USD:[9973.86, 9973.86, 9973.86, 6682.48, 6682.48, 6682.48, 6463.47, 6463.47, 6463.47, 6463.47]
  },
  'Cabled Boretrak CDU Logger': {
    USD:[1229.66, 1229.66, 1229.66, 1058.48, 1058.48, 1058.48, 1058.48, 1058.48, 1058.48, 1058.48]
  },
  'C-ALS': {
    USD:[46224.95, 46224.95, 46224.95, 30970.72, 30970.72, 30970.72, 20750.38, 20750.38, 20750.38, 16757.38]
  },
  'Gyro C-ALS probe only': {
    USD:[52861.24, 52861.24, 52861.24, 35417.03, 35417.03, 35417.03, 23729.41, 23729.41, 23729.41, 16189.70]
  },
  'Gyro C-ALS System': {
    USD:[65827.50, 65827.50, 65827.50, 44104.43, 44104.43, 44104.43, 29549.96, 29549.96, 29549.96, 28064.13]
  },
  'WIRELESS RBT System': {
    USD:[7979.08, 7979.08, 7979.08, 5345.99, 5345.99, 5345.99, 4564.55, 4564.55, 4564.55, 4564.55]
  },
  'WIRELESS RBT Without PDA': {
    USD:[7646.63, 7646.63, 7646.63, 5123.24, 5123.24, 5123.24, 4564.55, 4564.55, 4564.55, 4564.55]
  },
  'WIRELESS RBT PDA': {
    USD:[450.64, 450.64, 450.64, 450.64, 450.64, 450.64, 450.64, 450.64, 450.64, 450.64]
  },
  'ILM-35': {
    USD:[1259.50, 1259.50, 1259.50, 1084.68, 1084.68, 1084.68, 1084.68, 1084.68, 1084.68, 1084.68]
  },
  'ILM-150': {
    USD:[1259.50, 1259.50, 1259.50, 1084.68, 1084.68, 1084.68, 1084.68, 1084.68, 1084.68, 1084.68]
  },
  'ILM-500': {
    USD:[1492.09, 1492.09, 1492.09, 1303.45, 1303.45, 1303.45, 1303.45, 1303.45, 1303.45, 1303.45]
  },
  'ILM-1200': {
    USD:[2462.83, 2462.83, 2462.83, 2173.29, 2173.29, 2173.29, 2173.29, 2173.29, 2173.29, 2173.29]
  },
  'BT2 Basic System': {
    USD:[7231.71, 7231.71, 7231.71, 5051.36, 5051.36, 5051.36, 5051.36, 5051.36, 5051.36, 5051.36]
  },
  'BT2 Advanced System': {
    USD:[9973.31, 9973.31, 9973.31, 6682.11, 6682.11, 6682.11, 5051.36, 5051.36, 5051.36, 5051.36]
  },
  'FIX1 System': {
    USD:[19943.98, 19943.98, 19943.98, 13362.46, 13362.46, 13362.46, 9923.25, 9923.25, 9923.25, 9923.25]
  },
  'MERLIN LT System': {
    USD:[21277.57, 21277.57, 21277.57, 14255.97, 14255.97, 14255.97, 13482.07, 13482.07, 13482.07, 13482.07]
  },
  'MERLIN System': {
    USD:[35656.56, 35656.56, 35656.56, 23889.90, 23889.90, 23889.90, 20123.38, 20123.38, 20123.38, 20123.38]
  }
}
const Product = ['Quarryman LR System', 'Quarryman SR System', 'WIFI Voidscanner System', 'Voidscanner System', 'VS+ System', 'Cabled 35M Boretrak', 'Cabled 65M Boretrak', 'Cabled Boretrak CDU Logger', 'C-ALS', 'Gyro C-ALS probe only', 'Gyro C-ALS System', 'WIRELESS RBT System', 'WIRELESS RBT Without PDA', 'WIRELESS RBT PDA', 'ILM-35', 'ILM-150', 'ILM-500', 'ILM-1200', 'BT2 Basic System', 'BT2 Advanced System', 'FIX1 System', 'MERLIN LT System', 'MERLIN System'];
const ServiceCenter = [
  { key: 'Canada', val: 'North and South America (Canada Service Centre)' },
  { key: 'Australia', val: 'Asia-Pacific (Australia Service Centre)' },
  { key: 'York, UK', val: 'Europe & Africa (United kingdom Service Centre)' }
];
const ServiceCenterAddress = {
  Canada: 'North and South America (Canada Service Centre)\nCarlson Canada\n6683 Fourth Line Rd.\nNorth Gower, ON\nK0A 2T0\nCanada\nE-Mail: lsca@carlsonsw.com\nTel: 606-564-5028',
  Australia: 'Asia-Pacific (Australia Service Centre)\nCarlson Software Australia Pty Ltd\n43 Stubbs Street\nKensington, VIC 3031\nAustralia\nE-Mail: lsau@carlsonsw.com\nTel: +61 3 9021 0861',
  'York, UK': 'Europe & Africa (United kingdom Service Centre)\nCarlson EMEA\nHalifax House, Unit 1/2\nSouthfield Lane\nTockwith, York\nNorth Yorkshire, YO26 7QP\nUnited Kingdom\nE-Mail: Lmd_service@carlsonsw.com\nTel: + 44 (0) 1423 36924'
};
const Warranty = ['Yes', 'No'];

export { Americas, APAC, Currency, Price, Product, ServiceCenter, ServiceCenterAddress, Warranty };



// WEBPACK FOOTER //
// ./src/components/lib/LMD.js